export default "__VITE_ASSET__CntEwY31__"